import { render, staticRenderFns } from "./FileViewer.vue?vue&type=template&id=5085a25e&scoped=true&"
import script from "./FileViewer.vue?vue&type=script&lang=js&"
export * from "./FileViewer.vue?vue&type=script&lang=js&"
import style0 from "./FileViewer.vue?vue&type=style&index=0&id=5085a25e&lang=scss&scoped=true&"
import style1 from "./FileViewer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5085a25e",
  null
  
)

export default component.exports